import { sleep } from './sleep';

export async function retry<T>(fn: () => Promise<T>, maxRetry = 30, retryNumber = 0, interval = 1000): Promise<T> {
    try {
        return await fn();
    } catch (e) {
        if (retryNumber === maxRetry) {
            throw e;
        }

        await sleep(interval);

        return retry(fn, maxRetry, retryNumber + 1, interval);
    }
}
